import React, { PropsWithChildren, ReactElement } from 'react';
import { Spinner } from 'components/core';
import { useIssueFormLoading } from 'store/issueForm';

/** Renders its children once the issue form is loaded (the store loads it). */
function WithIssueForm({ children }: PropsWithChildren): ReactElement {
  const loading = useIssueFormLoading();

  if (loading) {
    return <Spinner reason='Loading issue form' />;
  }
  return <>{children}</>;
}

export const withIssueForm =
  <TProps extends object>(Component: React.ComponentType<TProps>) =>
  (props: TProps): ReactElement => (
    <WithIssueForm>
      <Component {...props} />
    </WithIssueForm>
  );
